"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NullFudaoPassedTimeCounter {
    StartCount(fudaoId) { }
    EndCount(fudaoId) { }
}
exports.NullFudaoPassedTimeCounter = NullFudaoPassedTimeCounter;
exports.NullFudaoPassedTimeCounterSingleton = new NullFudaoPassedTimeCounter();
//# sourceMappingURL=NullFudaoPassedTimeCounter.js.map